import React from "react";
import QTextBox from "../../../../common/components/QTextBox";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {config} from "../../../../config";
import {Col, Row} from "reactstrap";
import {Formik} from "formik";
import QButton from "../../../../common/components/QButton";
import {useDispatch} from "react-redux";
import {setToast} from "../../../../app/rootReducer";
import SetupApi from "../../../../common/api/functions/Setup";
import {SetupInterface} from "../../../../interfaces/private/SetupInterface";
import {useHistory} from "react-router-dom";
import {QHelpers} from "../../../../common/helpers";
import {RouteDefine} from "../../../../routes/RouteDefine";
import {useTranslation} from "react-i18next";
import QLoading from "../../../../common/components/QLoading";

interface Props {
    model: SetupInterface,
    setOpen: Function,
    setLoadingFunc: Function,
    setSetup: Function,
}

const BodyEconomicComponent: React.FC<Props> = ({model, setOpen, setLoadingFunc, setSetup}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {t } = useTranslation();
    const [submitting, setSubmitting] = React.useState(false);
    
    return (
        <React.Fragment>
            <Formik
                initialValues={{'pensopay_api_key':model.pensopay_api_key}}
                onSubmit={async (values: any) => {
                    setSubmitting(true);
                    try {
                        const response = await SetupApi.update(values);
                        if (response.status === config.STATUS_CODE.OK) {
                            await setOpen(false);
                            await setLoadingFunc(true);
                            await dispatch(setToast({
                                message: "Update success",
                                type: config.TOAST_TYPE.SUCCESS
                            }));
                        } else {
                            await dispatch(setToast({
                                message: response?.data?.message || "Update failed",
                                type: config.TOAST_TYPE.ERROR
                            }));
                        }
                    } catch (error: any) {
                        // Backend returns error with structure: { error: true, message: "...", data: [] }
                        const errorMessage = error?.response?.data?.message || error?.message || "Connection failed. Please check your API key.";
                        await dispatch(setToast({
                            message: errorMessage,
                            type: config.TOAST_TYPE.ERROR
                        }));
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                {formik => {

                    return (
                        <React.Fragment>
                            <QLoading loading={submitting} />
                            {submitting && (
                                <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 1000,
                                    textAlign: 'center',
                                    color: '#666',
                                    fontSize: '16px',
                                    fontWeight: 500
                                }}>
                                    <div className="mb-2">
                                        <i className="las la-sync la-spin" style={{fontSize: '32px', color: '#FF6B35'}}></i>
                                    </div>
                                    Validating Pensopay API key...
                                </div>
                            )}
                            <Row>
                                <Col>
                                    <QTextBox
                                        label={'Api key'}
                                        value={formik.values.pensopay_api_key}
                                        onChange={(value: string) => {
                                            formik.setFieldValue('pensopay_api_key', value)
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className={'d-flex justify-content-end gap-2'}>
                                        <QButton
                                            type={'default'}
                                            onClick={() => {
                                                setOpen(false)
                                            }}
                                            content={t("common.button.cancel")}
                                        />

                                        <QButton
                                            type={'primary'}
                                            onClick={() => {
                                                formik.handleSubmit()
                                            }}
                                            content={submitting ? "Validating..." : t("common.button.submit")}
                                            disabled={submitting}
                                        />

                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    )
                }}
            </Formik>
        </React.Fragment>
    )
}

export default BodyEconomicComponent
